import produce from 'immer'

import { EInvoiceHistory } from '../data'

interface ConvertedEInvoiceHistoryResponse
  extends Omit<EInvoiceHistory, 'invoiceDate' | 'submittedAt'> {
  invoiceDate: Date
  submittedAt: Date
}

/**
 * Converts a list of EInvoiceHistory objects by transforming date strings into Date objects.
 *
 * This function uses the Immer library to create a new list of converted EInvoiceHistory objects.
 * The conversion process involves:
 *
 * 1. Checking if any data exists (returns empty array if no data).
 * 2. Transforming date strings (invoiceDate and submittedAt) into Date objects
 *    for easier filtering and sorting in tables.
 *
 * @param {EInvoiceHistory[] | undefined} responses - The list of EInvoiceHistory objects to be converted
 * @returns {EInvoiceHistory[]} - The list of converted EInvoiceHistory objects with Date objects or an empty array if undefined
 */
export function convertEInvoiceHistoryDates(
  responses: EInvoiceHistory[] | undefined,
) {
  if (!responses) return []

  const convertedEInvoiceHistoryResponses = produce(
    responses,
    (draft: ConvertedEInvoiceHistoryResponse[]) => {
      draft?.forEach(response => {
        response.invoiceDate = new Date(response.invoiceDate)
        response.submittedAt = new Date(response.submittedAt)
      })
    },
  )

  return convertedEInvoiceHistoryResponses
}
